export default __webpack_public_path__ + "static/media/related-post-03.07382505.jpg";